import styled from 'styled-components'
export interface IContainer {
    // id should help QA
    id: string
    reverseColor?: boolean
}

export const Container = styled.span<IContainer>`
    font-weight: 400;
    font-size: 14px;
    font-family: ${properties => properties.theme.variables.fontFamily.title};
    color: #fff;
    background-color: rgba(0, 0, 0, 0.5);
    @media only screen and (min-width: 810px) {
        background-color: transparent;
    }
`
